const LockIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      viewBox="0 0 10 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M7 5.204v-.818c0-1.61-1-2.004-2-2.004s-2 .394-2 2.004v.818a6.035 6.035 0 00-2 1.152v-1.97C1 2.24 2.79.5 5 .5s4 1.74 4 3.886v1.97a6.036 6.036 0 00-2-1.152z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 16.5c2.761 0 5-2.175 5-4.858S7.761 6.785 5 6.785s-5 2.174-5 4.857C0 14.325 2.239 16.5 5 16.5zm0-2.915c1.105 0 2-.87 2-1.943S6.105 9.7 5 9.7s-2 .87-2 1.943.895 1.943 2 1.943z"
        fill="currentColor"
      />
    </svg>
  )
}

export default LockIcon
